import { Container } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import RecordTimeline from '@components/RecordTimeline';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';
import TimelineLoader from '@components/TimelineLoader';

import { useGetPatientTimelineRecords } from '@hooks/api/patient-record';
import { useIsMobile } from '@hooks/useIsMobile';

import { ShareType } from 'generated/types';

const Timeline: React.FC = () => {
  const mobile = useIsMobile();

  const { data, loading } = useGetPatientTimelineRecords({
    appointment: true,
    diagnostic_report: true,
    emergency_visits_encounter: true,
    hospitalizations_encounter: true,
    immunization: true,
    procedure: true,
  });

  return (
    <Container sx={{ marginTop: mobile ? '20px' : '40px' }} maxWidth="md">
      <TimelineLoader count={mobile ? 4 : 7} loading={loading}>
        <ShareCollectionButton share_type={ShareType.Timeline} />
        <RecordTimeline order="desc" data={data} />
      </TimelineLoader>
    </Container>
  );
};

export default withErrorBoundary(React.memo(Timeline), {
  FallbackComponent: ErrorBoundaryFallback,
});
